import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-78a5bd1a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "relative flex flex-col p-11 modal-content" };
const _hoisted_2 = { class: "self-center mb-8 text-4xl font-bold text-center heading text-primary-1000 dark:text-gray-300" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.pricing'),
    compatConfig: {
        COMPONENT_V_MODEL: false
    }
};
import transitions from '@/helpers/transitions';
import Dialog from '@/components/Dialog.vue';
import Modal from '@/components/Modal.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import PricingToggleableOptions from './PricingToggleableOptions.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'PricingModal',
    props: {
        isOpen: { type: Boolean },
        title: null,
        paymentPeriod: null,
        loading: { type: Boolean }
    },
    emits: ["update:isOpen", "choice", "update:paymentPeriod"],
    setup(__props, { emit }) {
        function handlePlanChoice(plan) {
            emit('choice', plan);
        }
        function handlePaymentPeriodUpdate(period) {
            emit('update:paymentPeriod', period);
        }
        const { scale } = transitions;
        const { scaleIn, scaleOut } = scale;
        return (_ctx, _cache) => {
            const _component_TransitionA11y = _resolveComponent("TransitionA11y");
            return (_openBlock(), _createBlock(_component_TransitionA11y, {
                css: false,
                enter: _unref(scaleIn),
                leave: _unref(scaleOut)
            }, {
                default: _withCtx(() => [
                    (__props.isOpen)
                        ? (_openBlock(), _createBlock(Modal, { key: 0 }, {
                            default: _withCtx(() => [
                                _createVNode(Dialog, { class: "my-10" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_1, [
                                            _createElementVNode("button", {
                                                class: "absolute w-6 h-6 top-10 right-10",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:isOpen', false)))
                                            }, [
                                                _createVNode(SvgIcon, { name: "search-cross" })
                                            ]),
                                            _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.title || _ctx.$t('title')), 1),
                                            _createVNode(PricingToggleableOptions, {
                                                "payment-period": __props.paymentPeriod,
                                                loading: __props.loading,
                                                onChoice: handlePlanChoice,
                                                "onUpdate:paymentPeriod": handlePaymentPeriodUpdate
                                            }, null, 8, ["payment-period", "loading"])
                                        ])
                                    ], undefined, true),
                                    _: 1
                                })
                            ], undefined, true),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ], undefined, true),
                _: 1
            }, 8, ["enter", "leave"]));
        };
    }
});
